module.exports = __webpack_public_path__ + "static/media/icon_communication_old.ea7a09bd.svg";